import type { PropsWithChildren } from 'react';
import { Children, cloneElement, isValidElement } from 'react';
import { createGlobalStyle } from 'styled-components';
import { INTERACTIVE_DATA_ATTRIBUTE } from './constants';

interface InteractiveDeactivationProps extends PropsWithChildren {
  isInteractive?: boolean;
}

export const InteractiveOnDeactivation = ({
  children,
  isInteractive
}: InteractiveDeactivationProps) => {
  if (!children) return null;
  if (!isInteractive) return children;

  return (
    <>
      <InteractiveGlobalStyles />
      {Children.map(children, (child) => {
        if (isValidElement(child)) {
          return cloneElement(child, {
            ...child.props,
            [INTERACTIVE_DATA_ATTRIBUTE]: 'true'
          });
        }
        return child;
      })}
    </>
  );
};

const InteractiveGlobalStyles = createGlobalStyle`
  [${INTERACTIVE_DATA_ATTRIBUTE}='true'] {
    pointer-events: auto;
    & * {
      pointer-events: auto;
    }
  }
`;
